import React from 'react';
import TestManageScreen from './screens/TestManageScreen';

export default function TestManage() {
  return <TestManageScreen />;
}
